import React from 'react';
import { PRIVACY_CONTACT_EMAIL, PRIVACY_NOTICE_URL } from '../config/privacy';

/**
 * Footer - shared Hub footer with project funding information.
 * `containerClassName` sets the content width and side padding so the footer
 * lines up with the page it is on.
 */
export const Footer = ({ containerClassName = 'page-column px-5 sm:px-6 xl:px-[26px]' }) => (
  <footer
    className="border-t border-black/[0.14] bg-transparent"
    aria-label="Project funding and legal information"
  >
    <div className={`mx-auto w-full py-5 ${containerClassName}`}>
      <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
        <div className="flex flex-col gap-3 lg:w-[280px] lg:flex-shrink-0">
          <img
            src="/livebetter_sidebar_logo.png"
            alt="LiveBetter"
            className="h-auto w-[210px] max-w-full object-contain"
          />
          <p className="m-0 text-[13px] font-medium leading-[1.5] text-lb-muted">
            &copy; 2026 LiveBetter. All Rights Reserved.
          </p>
          {(PRIVACY_NOTICE_URL || PRIVACY_CONTACT_EMAIL) && (
            <p className="m-0 flex flex-wrap gap-x-3 gap-y-1 text-[12px] leading-[1.5] text-lb-muted">
              {PRIVACY_NOTICE_URL && (
                <a
                  href={PRIVACY_NOTICE_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-lb-green-primary hover:underline rounded outline-none focus-ring"
                >
                  Privacy notice
                </a>
              )}
              {PRIVACY_CONTACT_EMAIL && <span>Data protection: <span className="select-all">{PRIVACY_CONTACT_EMAIL}</span></span>}
            </p>
          )}
        </div>

        <div className="flex max-w-[900px] flex-col gap-4 sm:flex-row sm:items-start">
          <img
            src="/eu-life-logo.png"
            alt="Co-funded by the European Union LIFE programme"
            className="h-auto w-[230px] max-w-full flex-shrink-0 object-contain"
          />

          <div className="space-y-2 text-[12px] leading-[1.45] text-lb-muted">
            <p className="m-0">
              This project has received funding from the European Union&rsquo;s LIFE research and innovation programme
              under grant agreement No 101215721.
            </p>
            <p className="m-0">
              Funded by the European Union. Views and opinions expressed are, however, those of the author(s) only and
              do not necessarily reflect those of the European Union or the European Research Executive Agency - REA.
              Neither the European Union nor REA can be held responsible for them.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
